import {DecimalPipe} from '@angular/common';
import {Directive, ElementRef, Host, HostListener, Input, OnInit, Optional} from '@angular/core';
import {NgControl} from '@angular/forms';
import {NumericDirective} from '../validation/numeric.directive';

@Directive({
    selector: '[transformNumber][formControlName]'
})
export class TransformNumberDirective implements OnInit {

    @Input()
    digitsInfo = null;

    constructor(private readonly ngControl: NgControl,
                private readonly elementRef: ElementRef,
                private readonly decimalPipe: DecimalPipe,
                @Optional() @Host() public numericDirective: NumericDirective) {
    }

    @HostListener('blur')
    public addDelimiter(): void {
        if (!this.ngControl || !this.ngControl.control || !this.ngControl.control.value) {
            if (this.numericDirective?.decimal !== null && this.ngControl?.control?.value === 0) {
                this.elementRef.nativeElement.value = '0,00';
            }
            return;
        }
        try {
            let digits = '.0-0';
            const valueString = (+this.ngControl.control.value).toString();
            if (this.numericDirective?.decimal !== null) {
                if (this.digitsInfo !== null) {
                    digits = this.digitsInfo;
                } else {
                    let commaLendth = valueString.indexOf('\.') !== -1 ? valueString.split('.')[1].length : 2;
                    commaLendth = commaLendth < 2 ? 2 : commaLendth;
                    digits = `.${commaLendth}-${commaLendth}`;
                }
            }
            this.elementRef.nativeElement.value = this.decimalPipe.transform(valueString, digits, 'de-DE');
        } catch {
        }
    }

    public ngOnInit(): void {
        this.addDelimiter();
    }

}
